export default {
  state: {
    showCheck: false
  },
  mutations: {
    SET_SHOW_CHECK: (state, showCheck) => {
      state.showCheck = showCheck
    }
  },
  actions: {
    SetShowCheck({ commit }, showCheck) {
        commit('SET_SHOW_CHECK', showCheck)
    },
  }
}